import { toRefs, ref, watch, computed, Ref, unref } from "@vue/composition-api";
import { Campo, Config, Param } from "../../models";
import useFetchData from "../../composition/useFetchData";
import useValores from "../../composition/useValores";
import useTimeout from "@/shared/composition/useTimeout";

export default function useContenido(config: Config | Ref<Config>, campos: Ref<unknown[]> = ref()) {

    const lastCampos = ref()

    const getUrl = (fuente, modelo) => {

        const query = {
            ...fuente,
            modelo: JSON.stringify(modelo) || ""
        }

        const modeloStr = new URLSearchParams(query).toString()
        const { url } = unref(config);

        return url && (url + "?" + modeloStr)
    }

    const getBody = (contentType: string, body) => {

        console.log({ body })

        if (contentType == "formEncoded") {
            const encoded = new URLSearchParams({ ...body })
            console.log({ encoded })
            return encoded
        }
        else if (contentType == "formData") {
            const data = new FormData()

            for (const [k, v] of Object.entries(body)) {
                const items = Array.isArray(v) ? v : [v]

                items.forEach(v => data.append(k, v))
            }
            return data
        }

        return JSON.stringify(body)
    }

    const getOpciones = (fuente, modelo) => {

        const { contentType, metodo = "get", url } = unref(config)
        const isPost = metodo === "post"

        const obj = {
            method: metodo,
            body: isPost ? getBody(contentType, modelo) : null,
            url: isPost ? url : getUrl(fuente, modelo),
            headers: {
                'Content-Type': "application/json"
            }
        }

        if (contentType == "formData") { // valor como constante por encapsular
            delete obj.headers["Content-Type"]
        }

        return obj
    }

    const { fetchData, data, cargando, error, limpiar } = useFetchData()

    const toLower = (valor) => {
        return valor?.toString().trim().toLowerCase()
    }

    const filtrarJsonObj = (obj, fuente) => {
        return Object.entries(fuente || {}).every(([k, v]) => {

            const data = toLower(obj[k])
            const valor = toLower(v) || ""

            return data.indexOf(valor) == 0
        })
    }

    const filtrarJson = (json, fuente) => {

        const filtrados = []

        for(const obj of json){
            const valido = filtrarJsonObj(obj, fuente)

            if(valido){
                filtrados.push(obj)
            }
            
            if(filtrados.length >= 10){
                break
            }
        }

        return filtrados;
    }

    const cargar = async (fuente) => {

        const { url, modelo: modeloConfig } = unref(config) || {}

        if (!url) {
            console.warn("Fetch detenido, no hay url")
            limpiar()
            return
        }

        const { asignarDesdeObj } = useValores(fuente)
        const modelo = asignarDesdeObj(modeloConfig) || fuente
        const ext = ".json"
        const isJson = url.lastIndexOf(ext) == url.length - ext.length
        const opciones = isJson ? { url } : getOpciones(fuente, modelo)

        await fetchData(opciones)

        // console.log({ urlJson })

        if (isJson) {
            data.value = filtrarJson(data.value, modelo)
        }
    }

    const checkIgualdad = (a, b) => {
        return JSON.stringify(a) === JSON.stringify(b)
    }

    const validarCampos = () => {
        const test = checkIgualdad(campos.value, lastCampos.value)

        if (!test) {
            data.value = null;
        }
    }

    const { reset } = useTimeout();

    const cargarDataTest = async (fuente) => {
        // validarCampos()
        await reset(async () => {
            await cargar(fuente); // Intentar sin await
        });
        lastCampos.value = campos.value
    }

    const dataComp = computed(() => {

        const { getValor } = useValores(data.value)
        const path = unref(config)?.dataPath?.toString()

        return path ? getValor(path) : data.value
    })

    return {
        data: dataComp,
        cargar,
        cargando,
        error,
        items: computed(() => Array.isArray(data.value) ? data.value : []),
        validarCampos,
        lastCampos,
        cargarDataTest,
        dataOriginal: data
    }

}